import Shared from '../../../../../asset/shared.png'
import Edit from '../../../../../asset/bookmark.png'
import Delete from '../../../../../asset/bin.png'
import Close from '../../../../../asset/close.png'
import { store } from '../../../../../../src/lib/store'

export function createInfoContent(data, callback, dispatchFunction) {
  let { mapReference, mapObj, mapPhotoObj, marker, photo, infoWindow, openInfoWindowClose, token } = data;
  let { editFunction, deleteFunction, closeFunction, updateInfoWindow, editHuntWind } = callback
  let newInfoWindow

  const reduxState = store.getState();
  const { userPreferences } = reduxState;

  const infoWindowContent = (value, handleEdit) => {

    function editFunctionCb() {
      editFunction(newInfoWindow)
    }

    function deleteFunctionCb(value) {
      deleteFunction(value.id)
    }

    function editHuntFunctionCb() {
      editHuntWind(newInfoWindow)
    }

    let latitude = parseFloat(marker.latitude).toFixed(5)
    let longitude = parseFloat(marker.longitude).toFixed(5)

    const container = document.createElement('div');
    container.style = `padding: 10px; height: 165px; width:150px; background-color: black`;
    // Create the content HTML
    container.innerHTML = `
        <div style="width:100%;">
        <a id="close">
            <img style="width: 10%; height: 50%; object-fit: cover; float: right;  margin-top: -10px; " src=${Close} alt="Edit"></img>
        </a>
        </div>  
          <span  class="info-box-span-heading">${marker.name}</span>
          <h6 class="info-box-head">Lattitude: <span class="info-box-span">${latitude}</span></h6>
          <h6 class="info-box-head">Longitude: <span class="info-box-span">${longitude}</span></h6>        
        <div style="display:flex; margin-top:10px;margin-right: 10px;">
        <div style="width: 50%; height: 70px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
        <a id="editButton">
          <div style="width: 30px; height: 30px; border-radius: 50%; margin-bottom: 3px;overflow: hidden; border: 2px solid green; display: flex; align-items: center; justify-content: center;">
            <img style="width: 50%; height: 50%; object-fit: cover;" src=${Edit} alt="Edit"></img>
          </div>
        </a>
        <p>Save</p>
        </div>         
        <div style="width: 50%; height: 70px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
        <a id="deleteButton">
          <div style="width: 30px; height: 30px; border-radius: 50%;margin-bottom: 3px; overflow: hidden; border: 2px solid green;display: flex; align-items: center; justify-content: center;">
            <img style="width: 50%; height: 50%; object-fit: cover;" src=${Delete}></img>
          </div>
        </a>
        <p>Cancel</p>
        </div>
        </div>
        `;

    // Add event listeners to the buttons
    container.querySelector('#editButton').addEventListener('click', editFunctionCb);
    container.querySelector('#deleteButton').addEventListener('click', () => deleteFunctionCb(value));
    container.querySelector('#close').addEventListener('click', closeFunctionCb);

    // Append the container to the body
    document.body.appendChild(container);
    return container;
  };

  if (infoWindow) {
    infoWindow.infoWindowFunction.close()
  }

  newInfoWindow = new google.maps.InfoWindow({
    content: infoWindowContent(marker ? marker : photo),
    disableAutoPan: true, // Prevents the info window from panning the map to fully display itself
    pixelOffset: new google.maps.Size(0, -10), // Adjusts the position of the info window
    maxWidth: 544, // Maximum width of the info window
  });

  if (newInfoWindow) {
    dispatchFunction && dispatchFunction(newInfoWindow)
  }

  function closeFunctionCb() {
    closeFunction(newInfoWindow)
  }

  newInfoWindow.open(mapReference, mapObj ? mapObj : mapPhotoObj);
  newInfoWindow && updateInfoWindow(newInfoWindow)
}